// src/components/WalletConnect.js

import React from 'react';
import { useWallet } from '../hooks/useWallet';
import './WalletConnect.css';

const WalletConnect = () => {
  const { 
    account, 
    balance, 
    isConnecting, 
    isCorrectNetwork, 
    networkInfo,
    error, 
    isMetaMaskInstalled,
    connect, 
    disconnect, 
    switchToWorldLand 
  } = useWallet();

  // MetaMask 미설치 시
  if (!isMetaMaskInstalled) {
    return (
      <div className="wallet-container">
        <div className="wallet-card">
          <h3>MetaMask가 필요합니다</h3>
          <p>월드랜드 P2P 거래소를 사용하려면 MetaMask를 설치해주세요.</p>
          <a 
            href="https://metamask.io" 
            target="_blank" 
            rel="noopener noreferrer"
            className="install-button"
          >
            🦊 MetaMask 설치하기
          </a>
        </div>
      </div>
    );
  }

  // 연결되지 않은 상태
  if (!account) {
    return (
      <div className="wallet-container">
        <div className="wallet-card">
          <h3>MetaMask를 연결하세요</h3>
          <p>월드랜드 P2P 거래소에 오신 것을 환영합니다!</p>
          <button 
            onClick={connect} 
            disabled={isConnecting}
            className="connect-button"
          >
            {isConnecting && <span className="loading-spinner"></span>}
            {isConnecting ? '연결 중...' : '🦊 MetaMask 연결'}
          </button>
          {error && <div className="error-message">{error}</div>}
        </div>
      </div>
    );
  }

  // 연결된 상태
  return (
    <div className="wallet-info">
      <div className="account-info">
        <div>
          <strong>연결된 지갑:</strong> {account.slice(0, 6)}...{account.slice(-4)}
        </div>
        <div>
          <strong>WLC 잔액:</strong> {balance} WLC
        </div>
        {networkInfo && (
          <div>
            <strong>네트워크:</strong> {networkInfo.chainName}
            <span className={`network-badge ${networkInfo.isTestnet ? 'testnet' : 'mainnet'}`}>
              {networkInfo.isTestnet ? 'TESTNET' : 'MAINNET'}
            </span>
          </div>
        )}
      </div>
      
      {!isCorrectNetwork && (
        <div className="network-warning">
          <p className="warning-text">
            ⚠️ 지원되는 네트워크로 전환해주세요
          </p>
          <p style={{ fontSize: '14px', marginBottom: '10px', color: '#856404' }}>
            현재 연결된 네트워크에서는 거래소를 사용할 수 없습니다.
          </p>
          <button 
            onClick={() => switchToWorldLand('mainnet')}
            className="network-button"
          >
            메인넷으로 전환
          </button>
          <button 
            onClick={() => switchToWorldLand('testnet')}
            className="network-button"
          >
            월드랜드 테스트넷으로 전환
          </button>
          <button 
            onClick={() => switchToWorldLand('sepolia')}
            className="network-button"
          >
            Sepolia 테스트넷으로 전환
          </button>
        </div>
      )}

      {isCorrectNetwork && networkInfo && (
        <div className="network-info">
          <p className="network-info-text">
            ✅ 지원되는 네트워크에 연결되었습니다
          </p>
          <p style={{ fontSize: '14px', marginBottom: '0', color: '#0c5460' }}>
            {networkInfo.isTestnet 
              ? `${networkInfo.chainName}에서 안전하게 테스트할 수 있습니다.` 
              : '메인넷에서 실제 거래가 가능합니다.'
            }
          </p>
        </div>
      )}
      
      <button 
        onClick={disconnect}
        className="disconnect-button"
      >
        연결 해제
      </button>
      
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default WalletConnect;